import type { SxProps, Theme } from '@mui/material';

/** Gray section card, as in the bag-quality form. */
export const sectionSx: SxProps<Theme> = {
    backgroundColor: 'grey.100',
    border: (t) => `1px solid ${t.palette.divider}`,
    px: { xs: 2, sm: 3 },
    py: 3,
};

/** White input on top of a gray section. */
export const inputSx: SxProps<Theme> = {
    '& .MuiOutlinedInput-root': { backgroundColor: 'background.paper' },
};
